import React, { useState } from 'react';
import { Eye } from 'lucide-react';
import { useFileApi } from '../../hooks/useFileApi';
import { FileViewer } from './FileViewer';
import { showAlert } from '../../utils/sweetAlertUtils';

interface ImageLinkProps {
  fileId: string;
  label: string;
}

const ImageLink: React.FC<ImageLinkProps> = ({ fileId, label }) => {
  const [showViewer, setShowViewer] = useState(false);
  const [fileInfo, setFileInfo] = useState<{
    url: string;
    fileName: string;
    contentType: string;
  } | null>(null);
  const { getFileUrl } = useFileApi();

  if (!fileId) return null;

  const handleView = async () => {
    try {
      const response = await getFileUrl(fileId);
      if (response && response.data) {
        if (response.data.status !== 'Processed') {
          await showAlert({
            title: 'Almost there...',
            text: `Your file is being processed and checked for security. You'll be able to continue shortly. Please try again in a few seconds.`,
            icon: 'info'
          });
          return;
        }

        setFileInfo({
          url: response.data.url ?? '',
          fileName: response.data.fileName ?? '',
          contentType: response.data.contentType ?? ''
        });
        setShowViewer(true);
      }
    } catch (error) {
      console.error('Error getting file URL:', error);
      await showAlert({
        title: 'Error',
        text: 'An error occurred while trying to access the file.',
        icon: 'error'
      });
    }
  };

  return (
    <>
      <div 
        className="flex items-center gap-2 mb-2 col-span-full text-sm text-secondary cursor-pointer hover:text-orange-400"
        onClick={handleView}
      >
        <Eye className="w-4 h-4" />
        <span>View {label}</span>
      </div>

      {showViewer && fileInfo && (
        <FileViewer
          fileName={fileInfo.fileName}
          sasUrl={fileInfo.url}
          onClose={() => setShowViewer(false)}
        />
      )}
    </>
  );
};

export default ImageLink;